import { createSelector } from "reselect";

const selectFilters = (state) => state.dashboardFilters;

const selectSelectedAppType = () =>
  createSelector(selectFilters, (filtersState) => filtersState.selectedFilters.selectedAppType);

const selectPeriod = () => createSelector(selectFilters, (filtersState) => filtersState.period);

const selectMarket = () => createSelector(selectFilters, (filtersState) => filtersState.market);

const selectSelectedMarket = () =>
  createSelector(selectFilters, (filtersState) => filtersState.selectedFilters.selectedMarket);

const selectSelectedGroup = () =>
  createSelector(selectFilters, (filtersState) => filtersState.selectedFilters.selectedGroup);

const selectDevice = () => createSelector(selectFilters, (filtersState) => filtersState.device);

const selectGroup = () => createSelector(selectFilters, (filtersState) => filtersState.group);

const selectDatesRange = () =>
  createSelector(selectFilters, (filtersState) => {
    return { from: filtersState.fromDate, to: filtersState.toDate };
  });

export {
  selectPeriod,
  selectMarket,
  selectSelectedMarket,
  selectDevice,
  selectDatesRange,
  selectSelectedAppType,
  selectGroup,
  selectSelectedGroup
};
